var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import 'rxjs/add/observable/of';
import { GetBlacklistAction } from '../blacklist/blacklist.actions';
import 'rxjs/add/operator/withLatestFrom';
import { DataSourceUtils } from '../../shared/utils/data-source-utils';
import { getBlacklistSelector, getBlacklistTotalSelector } from '../blacklist/blacklist.reducer';
import { DefaultParams } from '../blacklist/blacklist.config';
var BlacklistTableDataSource = /** @class */ (function (_super) {
    __extends(BlacklistTableDataSource, _super);
    function BlacklistTableDataSource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BlacklistTableDataSource.prototype.update = function () {
        this.store.dispatch(new GetBlacklistAction(this.params));
    };
    BlacklistTableDataSource.prototype.onConnect = function () {
        this.params = new DefaultParams();
        return this.store.select(getBlacklistSelector).withLatestFrom(this.store.select(getBlacklistTotalSelector));
    };
    return BlacklistTableDataSource;
}(DataSourceUtils));
export { BlacklistTableDataSource };
